document.addEventListener("DOMContentLoaded", function (event) {
    const dropdowns = document.querySelectorAll('[data-product-dropdown]')

    dropdowns.forEach(product => {
        const opener = product.querySelector('[data-items-list-opener]');
        const productList = product.querySelector('[data-items-list]');

        opener.addEventListener('click', () => {
            opener.classList.toggle('active')
            productList.classList.toggle('active')
        })
    })
})



